import { createFileRoute } from "@tanstack/react-router";
import { CallHistoryList } from "@/components/app/messaging-call/history/call-history-list";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Call } from "@/lib/icons/messaging-icons";
import { InboxBackButton } from "../-components/home/inbox-back-button";

type Filter = "all" | "missed";

export const Route = createFileRoute("/_authenticated/messaging/_inbox/calls")({
  validateSearch: (search: Record<string, unknown>): { filter?: Filter } => ({
    filter: search.filter === "missed" ? "missed" : undefined,
  }),
  component: CallsPage,
});

/** Every call the person made, answered or missed, as a phone's recents: call back from here. */
function CallsPage() {
  const { filter = "all" } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <header className="flex items-center gap-2 border-b px-3 py-2 md:px-4">
        <InboxBackButton />
        <Call className="text-muted-foreground size-4" />
        <h1 className="text-sm font-semibold">Calls</h1>
        <Tabs
          value={filter}
          onValueChange={(value) =>
            void navigate({ search: value === "missed" ? { filter: "missed" } : {}, replace: true })
          }
          className="ml-auto"
        >
          <TabsList className="h-8">
            <TabsTrigger value="all" className="text-xs">
              All
            </TabsTrigger>
            <TabsTrigger value="missed" className="text-xs">
              Missed
            </TabsTrigger>
          </TabsList>
        </Tabs>
      </header>
      <div className="min-h-0 flex-1 overflow-y-auto">
        <CallHistoryList key={filter} filter={filter} />
      </div>
    </div>
  );
}
